import { PublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import { acquireAccessToken } from "..";
import { msalConfig } from "../authConfig";
import _ from "lodash";

export const apiServer = process.env.REACT_APP_AWS_API_URL;
export const apiBaseUrl = `${apiServer}`;

export const unfiApi = axios.create({
  baseURL: apiBaseUrl,
});

// This should be the same instance you pass to MsalProvider
const msalInstance = new PublicClientApplication(msalConfig);

export const handleHttpResponse = (error: any = null) => {
  if (_.get(error, "response.status") === 400) {
    const errorMessage =
      error?.response?.data?.title ||
      error?.response?.data?.Message ||
      error?.response?.data?.message ||
      error?.response?.data ||
      "Bad Request!";
    console.error(`Error:  ${errorMessage}`);
  } else if (_.get(error, "response.status") === 406) {
    console.error(`Error:  ${error}`);
  } else if (_.get(error, "response.status") === 500) {
    const errorMessage = "Internal server error!";
    console.error(`Error:  ${errorMessage}`);
  } else if (_.get(error, "response.status") === 200) {
    const successMessage = "The operation completed successfully!";
    console.log(`Success:  ${successMessage}`);
  } else if (isUnauthorizedError(error)) {
    const errorMessage =
      error?.response?.data || "Unauthorized: Access is denied!";
    console.error(`Error:  ${errorMessage}`);
    // Logout current user
    localStorage && localStorage.clear();
    msalInstance.logoutRedirect();
  }
};

/**
 * authRequest :: AxiosConfig -> Promise Error AxiosResponse
 * AxiosConfig = Object
 * AxiosResponse = Object
 */
export const authRequest = async (config: any) => {
  const token = await acquireAccessToken();
  const withAuthTokenConfig = _.merge(config, {
    headers: { Authorization: `Bearer ${token}` },
  });

  try {
    const data = await unfiApi(withAuthTokenConfig);
    handleHttpResponse();
    return data;
  } catch (error) {
    handleHttpResponse(error);
    return await Promise.reject(error);
  }
};

/**
 * isProd :: () -> Boolean
 */
export const isProd = () => process.env.NODE_ENV === "production";

/**
 * isUnauthorizedError :: Error -> Boolean
 */
export const isUnauthorizedError = (error: any) =>
  _.get(error, "response.status") === 401;

export const isValidHttpUrl = (urlString: string) => {
  let url;
  try {
    url = new URL(urlString);
  } catch (_) {
    return false;
  }
  return (
    url.protocol === "http:" ||
    url.protocol === "https:" ||
    url.protocol === "blob:"
  );
};

export function ordinalSuffixOf(i: number) {
  let j = i % 10,
    k = i % 100;
  if (j === 1 && k !== 11) {
    return i + "st";
  }
  if (j === 2 && k !== 12) {
    return i + "nd";
  }
  if (j === 3 && k !== 13) {
    return i + "rd";
  }
  return i + "th";
}
